<template>
  <l-circle-marker
    v-for="(point, index) in locations"
    :key="'marker'+ index"
    :lat-lng="[point.Latitude, point.Longitude]"
    :radius="point.hovered || point.active ? markerOptions.hoverRadius : markerOptions.radius"
    :color="markerOptions.color"
    :fillColor="point.hovered || point.active ? markerOptions.hoverFillColor : markerOptions.fillColor"
    :weight="markerOptions.weight"
    :opacity="markerOptions.opacity"
    :fillOpacity="point.hovered || point.active ? markerOptions.hoverFillOpacity : markerOptions.fillOpacity"
    :bubblingMouseEvents="false"
    @click="() => onMarkerClick(point)"
    @mouseover="(e) => onMarkerMouseOver(point)"
    @mouseout="() => onMarkerMouseOut(point)"
  >
  
  </l-circle-marker>
</template>

<script setup>
import { LCircleMarker } from '@vue-leaflet/vue-leaflet';
import { computed } from "vue";

import { useStore } from 'vuex';
const store = useStore();

store.dispatch('loadMarkers');

const locations = computed(() => store.getters.locations);

// Custom marker style using circleMarker
const markerOptions = {
  radius: 5, // Radius of the circle
  fillColor: '#FF5362', // Custom color
  hoverFillColor: '#FF5362',
  color: '#FFF', // Border color
  weight: 1,
  opacity: 1,
  fillOpacity: 0.6,
  hoverFillOpacity: 1,
  hoverRadius: 7
};

function onMarkerClick(point) {
  // console.log('Marker clicked:', point);
  point.index = store.getters.maxIndex;
  store.dispatch('updateMarker', point);
  store.dispatch('updateFeatured', point);
}

function onMarkerMouseOver(point) {
  point.hovered = true;
}

function onMarkerMouseOut(point) {
  point.hovered = false;
}

</script>

<style>
.leaflet-tooltip-pane {
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  padding: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

</style>